import { Component, OnInit }            from '@angular/core';
import { Router }                       from '@angular/router';
import { UserService }                  from '../../_services/user.service'; 
import { RecaptchaModule , RecaptchaFormsModule}              from 'ng-recaptcha';

//import { IMG_ANI_REFRESH}               from '../../_models/constants';
import { first }          from 'rxjs/operators';
import { Subscription } from 'rxjs';

export interface FormModel {
  captcha?: string;
}

@Component({
  selector: 'ind-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  model: any = {};
  formModel: FormModel = {};  
  loading:boolean = false;
  success:boolean = false;
  failure:boolean = false;
  doc: any;
  subscription: Subscription | null = null;
  constructor(
        private router: Router,
        private userService: UserService
    ) { }

  ngOnInit() {
    //this.IMG_ANI_REFRESH = IMG_ANI_REFRESH;
  }

  forgotyourpassword(){
        this.loading = true;
        this.subscription = this.userService.forgotyourpassword(this.model)
            .pipe(first())
            .subscribe(
                data => {//alert('Registration is successful');
                    this.model = {};
                    this.success = true;
                    //this.router.navigate(['/ind-login']);
                },
                error => {
                    //alert("The email specified is not registered as an individual. Please use a different email id or click on 'Register' link to register this email.")
                    this.failure = true;
                    this.loading = false;
                });
  }
  reloadPage(){
    window.location.reload();
  }
 ngOnDestroy(){
    try{
      this.subscription?.unsubscribe();
    }catch(e){

    }
  }
}
